import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { GearAppService, GearProxyService } from 'common-gear';
import { AppService, ColorPickerService, CommonMapService, CoreProxyService, CoreTypes, FormValidatorService, IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts, IMyDate, Modal, SharedCommonService, StringDateTimePipe } from 'common-cloudstudio';
import { Observable, of, Subscription, forkJoin } from 'rxjs';
import { MapService } from '../shared/services/map.service';
import { AgmMarker } from '@agm/core';
import { CustomerModule } from '../customer-modules/customer/customer.module';
import { switchMap, tap } from 'rxjs/operators';

declare var environment: any;
export class SnappedCoordinates {
  snappedPath: {
    coordinates: google.maps.LatLng;
    placeId: string;
  }[];
  snappedPolyline: google.maps.Polyline
}

export class assetsMapV2 extends CoreTypes.AssetMap {
  iconUrl: string;
}

@Component({
  selector: 'app-asset-tracking',
  templateUrl: './asset-tracking.component.html',
  styleUrls: ['./asset-tracking.component.scss']
})
export class AssetTrackingComponent implements OnInit, OnDestroy, OnChanges {
  today = new Date();
  @Input() accessToken;
  @Input() isSharedView = false;
  @Input() dateFrom: CoreTypes.DateTimeDT = {
    ...new CoreTypes.DateTimeDT(),
    Date: {
      Day: this.today.getDate(),
      Month: this.today.getMonth()+1,
      Year: this.today.getFullYear()
    }
  };
  @Input() showRoute = false;
  saveShowRouter = false;
  @Input() facilityId = 0;
  @Input() clientId = 0;
  @Input() assets: number[] = [];
  @Input() geozones: number[] = [];
  @Input() drivers: number[] = [];
  @Input() alarmFilters: CoreTypes.AssetTrackingAlarmFilters =  new CoreTypes.AssetTrackingAlarmFilters();
  @ViewChild('detailModal') detailModal: Modal;
  @ViewChild('showRouteModal') showRouteModal: Modal;
  assetsRoute: number[] = [];
  assetsListRoute: IMultiSelectOption[] = [];
  subscriptions: Subscription[] = []
  isCollapsed = true;
  markerArray: google.maps.Marker[] = [];
  longitudeCenter: number = -105.012516;
  latitudeCenter: number = 10.875404;
  _zoom: number = 1.9;
  errorMessage: string;
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'checkboxes',
    dynamicTitleMaxItems: 1,
    displayAllSelectedText: true,
    showCheckAll: true,
    showUncheckAll: true,
    selectionLimit: 0
  };
  mapReady: Boolean = false;
  assetsMultiSelectSettings: IMultiSelectSettings = { ...this.multiSelectSettings }
  multiSelectTexts: IMultiSelectTexts;
  debounceFilters: any;
  lastDate: CoreTypes.DateTimeDT = {
    ...new CoreTypes.DateTimeDT(),
    Date: {
      Day: this.today.getDate(),
      Month: this.today.getMonth()+1,
      Year: this.today.getFullYear()
    }
  };
  requestToken: string = null;
  detailRequestToken: string = null;
  assetsList: IMultiSelectOption[] = [];
  assetsFullList: CoreTypes.Asset[] = [];
  geozonesList: IMultiSelectOption[] = [];
  geozonesFullList: CoreTypes.Geozone[] = [];
  driversList: IMultiSelectOption[] = [];
  driversFullList: CoreTypes.AssetTrackingDrivers[] = [];
  bounds: google.maps.LatLngBounds;
  map: google.maps.Map
  polygons: google.maps.Polygon[] = [];
  mapAssets: assetsMapV2[] = [];
  isDestroyed = false;
  snappedCoordinates: SnappedCoordinates[] = [];
  assetDetail: CoreTypes.AssetTrackingDetailDataPacket;
  assetDetailDate: CoreTypes.DateTimeDT = null;
  assetDetailStatus = 1;
  executionNumber: number = 0;
  isToday = false;
  activeMarker: number = 0;
  detailActiveTab = 1;
  detailModalTabs: {description: string}[] = [];
  customerTabs = [];
  mapStyles = this.commonMapService.Styles;
  showCommercialPins = null;
  showSatellitalView = null;
  firstExecution: boolean = true;
  endpointsIDs:number[] = [];
  tags: number[] = [];
  tagsList: IMultiSelectOption[] = [];
  assetsForTags: number[] = [];
  assetTrackingParameters: CoreTypes.AssetTrackingParameters =  new CoreTypes.AssetTrackingParameters();
  assetTrackingPermissions: CoreTypes.AssetTrackingParametersToUse =  new CoreTypes.AssetTrackingParametersToUse();
  alarmsTags = {
    notAllowed: CoreTypes.AssetTrackingAlarmFiltersType.NotAllowed,
    usingTags: CoreTypes.AssetTrackingAlarmFiltersType.UsingTags
  }
  _dataTrackingSub: Subscription;
  private _intervalDataPackages = 10;
  timer: any;
  sizeIcon: any = { iconHeight: 50, iconWidth: 50};
  markerIcon: any | google.maps.ReadonlyIcon | google.maps.ReadonlySymbol;
  initialLatitude: number;
  initialLongitude: number;
  initialZoom: number;
  environment = environment;
  assetMapIcon: string = environment?.assetMapIcon ? environment?.assetMapIcon : 'fa-dolly';

  constructor(
    public appService: AppService,
    public gearAppService: GearAppService,
    private coreProxyService: CoreProxyService,
    private colorService: ColorPickerService,
    private datetimePipe: StringDateTimePipe,
    public mapService: MapService,
    public commonMapService: CommonMapService,
    private cdr: ChangeDetectorRef,
    public sharedCommonService: SharedCommonService,
    private formValidatorService: FormValidatorService,
    private customerModule: CustomerModule,
    private gearProxyService: GearProxyService
  ) {
  }

  ngOnInit(): void {
    this.firstExecution = true;
    this.customerModule.AssetTrackingTabs().then(tabs => {
      this.setDetailModalLiterals();
      if (!tabs?.length) { return; }
      this.customerTabs = tabs;
      this.customerTabs.forEach(item => this.detailModalTabs.push({description: item.description}));
    });

    if (!this.isSharedView) {
      this.facilityId = this.appService.getFacilityID();
      this.accessToken = this.appService.getAccessToken();
      this.clientId = this.appService.getClientID();
    }

    if (this.dateFrom === null) {
      this.dateFrom = {
        ...new CoreTypes.DateTimeDT(),
        Date: {
          Day: this.today.getDate(),
          Month: this.today.getMonth()+1,
          Year: this.today.getFullYear()
        }
      };
    }

    this.today.setHours(0, 0, 0, 0);

    if (this.appService.CoreCommonLiterals && this.gearAppService.GearMonitorLiterals) {
      this.setLiterals();
      this.initData();
    }

    this.subscriptions.push(this.gearAppService.onLiteralsSet.subscribe(() => {
      this.setLiterals();
      this.initData();
    }));

    this.subscriptions.push(this.gearAppService.onGearPermissionsSet.subscribe(() => {
      this.setLiterals();
    }))

    this.subscriptions.push(this.gearAppService.onChangeFacilityID.subscribe(async facilityId => {
      if (this.facilityId === facilityId || this.isSharedView) { return; }
      this.facilityId = facilityId;
      this.assetTrackingPermissions = new CoreTypes.AssetTrackingParametersToUse();
      this.showCommercialPins = null;
      this.showSatellitalView = null;
      this.requestToken = null;
      this.firstExecution = true;
      this.clientId = this.appService.getClientID();
      this.bounds = new google.maps.LatLngBounds();
      this.driversFullList = [];
      this.getAssetsPermissions();
    }));

    this.subscriptions.push(this.appService.onFacilitySet.subscribe(() => {
      if (this.facilityId && this.facilityId !== this.appService.getFacilityID()) {
        this.requestToken = null;
        if(this._dataTrackingSub) { this._dataTrackingSub.unsubscribe(); }
      }
    }))
  }

  initData() {
    forkJoin([
      this.getVehiclesIcons()
    ])
    .subscribe({
      complete: () => {
        this.getAssetsPermissions();
      }
    });
  }

  getAssetsPermissions() {
    this.getAssetTrackingParametersToUse().then(permission => {
      if(permission && permission.CanShowGeozones) { this.getGeozones(); }
      if(permission.CanFilterAssets || permission.CanFilterDrivers) { this.getAssets(); }
      if(!permission.CanFilterAssets && permission.AlarmFilters == this.alarmsTags.usingTags) {
        this.getAssetsAlertTags();
      }
      if(permission.AlarmFilters == 0 && !permission.CanFilterAssets && !permission.CanFilterDrivers && !permission.CanShowGeozones) {
        this.applyFilters();
      }
    });
  }

  setLiterals() {
    this.multiSelectTexts = {
      checkAll: this.appService.CoreCommonLiterals.MultiSelect_All_Male, // 'Select all'
      uncheckAll: this.appService.CoreCommonLiterals.None_Male, // 'Unselect all'
      checked: this.appService.CoreCommonLiterals.MultiSelect_X_Selected_Male, // 'item selected'
      checkedPlural: this.appService.CoreCommonLiterals.MultiSelect_X_Selected_Male,
      searchPlaceholder: this.appService.CoreCommonLiterals.MultiSelect_Find, //'Find'
      defaultTitle: this.appService.CoreCommonLiterals.Select, // 'Select'
      allSelected: this.appService.CoreCommonLiterals.MultiSelect_All_Male // 'All selected'
    };
    this.setDetailModalLiterals();
  }

  setDetailModalLiterals() {
    this.detailModalTabs = [
      {description: this.appService?.CoreCommonLiterals?.Details},
      {description: this.appService?.CoreCommonLiterals?.Sensors},
      {description: this.appService?.CoreCommonLiterals?.Alarms},
      {description: this.appService?.CoreCommonLiterals?.AssetVehicleDrivers},
    ]
  }

  ngOnChanges(data: SimpleChanges): void {
    if (!data) { return; }
    if (data.accessToken?.currentValue) { this.accessToken = data.accessToken.currentValue; }
    if (data.facilityID?.currentValue) { this.facilityId = data.facilityID.currentValue; }
    if (data.drivers?.currentValue) { this.drivers = data.drivers.currentValue; }
    if (data.assets?.currentValue) { this.assets = data.assets.currentValue; }
    if (data.alarmFilters?.currentValue) { this.alarmFilters = data.alarmFilters?.currentValue;}
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    const poiIndex = this.commonMapService.Styles.findIndex(s => s.featureType === 'poi');
    if (poiIndex > -1 && this.commonMapService.Styles[poiIndex].stylers[0]?.visibility) {
      this.commonMapService.Styles[poiIndex].stylers[0].visibility = 'off';
    }
    this._intervalDataPackages = 0;
    if(this.timer) { clearTimeout(this.timer); }
    this.timer = null;

    if(this._dataTrackingSub) { this._dataTrackingSub.unsubscribe(); }
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getVehiclesIcons() {
    return new Promise((resolve, reject) => {
      this.appService.mapIconSet.subscribe(icons => {
        if(!icons.length) return;
        resolve(icons);
      },
      error => {
        reject(error);
      })
    });
  }

  getAssetTrackingParametersToUse(): Promise<CoreTypes.AssetTrackingParametersToUse> {
    return new Promise((resolve, reject) => {
      if(this.isSharedView) {
        resolve(new CoreTypes.AssetTrackingParametersToUse);
        return
      };
      this.coreProxyService.AssetService.GetAssetTrackingParametersToUse(
        this.appService.getAccessToken(),
        this.appService.getClientID(),
        this.appService.getFacilityID(),
        data => {
          this.assetTrackingPermissions = data;
          resolve(data);
        },
        error => {
          this.appService.showException(error);
          reject(error);
        }
      )
    });
  };

  getGeozones() {
    // Clear geozones all lists
    if (!this.isSharedView) { this.geozones = []; }
    this.geozonesFullList = [];
    this.geozonesList = [];
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    this.coreProxyService.MasterEntityService.EnumGeozones(
      this.accessToken,
      this.clientId,
      res => {
        this.geozonesFullList = res;
        optionsList = res.map(x => {
          // Set all options as "active" by default
          // Return mapped value
          return {
            name: x.Description + ((x.ExternalCode) ? ' (' + x.ExternalCode + ')' : ''),
            id: x.GeozoneID
          };
        });
        this.geozonesList = optionsList;
        if (this.map) { this.drawGeozones(); }
      },
      err => {
        this.appService.showException(err);
      }
    );
  }

  getVehicleDrivers(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.isSharedView) { return resolve(); }
      if (this.driversFullList.length) { return this.filterVehicleDrivers(); }
      this.coreProxyService.AssetService.GetAssetTrackingDrivers(
        this.appService.getAccessToken(),
        this.appService.getFacilityID(),
        (drivers: CoreTypes.AssetTrackingDrivers[]) => {
          this.driversFullList = drivers;
          resolve();
        },
        error => {
          this.appService.showException(error);
          reject(error);
        }
      )
    });
  }

  filterVehicleDrivers() {

    this.clearAssetsRoutes();
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    const selectedAssets = this.assetsFullList.filter(a => this.assets.indexOf(a.AssetID) > -1);
    const assetDrivers = this.driversFullList.filter(driver =>
      selectedAssets.findIndex(a => a.AssetVehicleData.VehicleDrivers.indexOf(driver.DriverID) > -1) > -1
    );
    optionsList = assetDrivers.map(x => {
      return {
        name: `${x.Firstname} ${x.Lastname} (${x.EMail})`,
        id: x.DriverID
      };
    });

    let driversCount = this.driversList.length;
    this.driversList = optionsList;

    // Eliminar los conductores seleccionados que no estén en la lista
    if(!this.isSharedView && driversCount !== this.driversList.length) {
      let findDriver = this.driversList.filter(x => this.drivers.includes(x.id ));
      this.drivers = findDriver?.map(x => {
        return x.id;
      });
      // this.drivers = this.driversList.map(x => x.id);
    };
    if(!this.isSharedView && this.drivers.length && !this.driversList.length) {
      this.drivers = [];
    }
  }

  getAssets() {
    if (this.isSharedView) { return; }
    // Clear lists
    this.assets = [];
    this.assetsList = [];
    this.assetsRoute = [];
    this.assetsForTags = [];
    this.assetsListRoute = [];
    this.endpointsIDs = []
    this.drivers = [];
    this.mapAssets = [];
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    this.coreProxyService.AssetService.EnumAssets(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      res => {
        this.assetsFullList = res;

        optionsList = res.map(x => {
          //return all endpoints in assets
          x.EndpointsIDs.forEach(e => {
            this.endpointsIDs.push(e);
          });
          // Set all options as "active" by default
          this.assets.push(x.AssetID);
          this.assetsForTags.push(x.AssetID);
          this.mapAssets.push({
            ...new assetsMapV2(),
            Asset: x
          });
          // Return mapped value
          return {
            name: x.Description + ((x?.AssetVehicleData?.LicensePlateNumber) ? ' (' + x.AssetVehicleData.LicensePlateNumber + ')' : ''),
            id: x.AssetID
          };
        });
        this.assetsRoute = this.assets;
        this.assetsListRoute = optionsList;
        this.assetsList = optionsList;
        this.assetTrackingPermissions.CanFilterDrivers ? this.getVehicleDrivers().then(_ => { this.applyFilters(); }) : this.applyFilters();
        if(this.assetTrackingPermissions.CanFilterAssets && this.assetTrackingPermissions.AlarmFilters === this.alarmsTags.usingTags) {
          this.getAssetsAlertTags();
        }
      },
      err => {
        this.appService.showException(err);
      }
    );
  }

  onInitMap(map: any) {
    if(environment.useOfflineMode) {
      return;
    }
    var locations = [];
    this.mapReady = true;
    this.map = map;
    let mapOptions = {
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      }
    };
    this.map.setOptions(mapOptions)
    this.bounds = new google.maps.LatLngBounds();
    this.drawGeozones();
    this.setSettings();
    if (this.isSharedView) { this.applyFilters(); }
  }

  centerMapInitially() {
    if (!this.map) return;
  
    if (this.initialLatitude && this.initialLongitude) {
      this.map.setCenter(new google.maps.LatLng(this.initialLatitude, this.initialLongitude));
      if (this.initialZoom) {
        this.map.setZoom(this.initialZoom);
      }
    } else if (this.bounds) {
      this.map.fitBounds(this.bounds);
    }
  }

  drawGeozones() {
    // Clear polygons from the map
    this.polygons.forEach(p => p.setMap(null));
    this.geozonesFullList.forEach(geozone => {
      if (this.geozones.indexOf(geozone.GeozoneID) < 0) { return; }
      const paths: google.maps.MVCArray<google.maps.LatLng> = new google.maps.MVCArray<google.maps.LatLng>();

      geozone.Polygon.Points.forEach(point => {
        const path = new google.maps.LatLng(point[0], point[1]);
        paths.push(path);
      });
      if (this.polygons[geozone.GeozoneID]?.get('paths')) { return; }
      const polygon = new google.maps.Polygon({
        fillColor: this.colorService.rgbToHexa((geozone.Polygon.FillColor) ? geozone.Polygon.FillColor : 0),
        fillOpacity: geozone.Polygon.FillOpacity/100,
        strokeColor: this.colorService.rgbToHexa((geozone.Polygon.BorderColor) ? geozone.Polygon.BorderColor : 0),
        strokeOpacity: geozone.Polygon.BorderOpacity/100,
        strokeWeight: geozone.Polygon.BorderWidth,
        paths,
      });
      polygon.setMap(this.map);
      this.polygons[geozone.GeozoneID] = polygon;
    });
  }

  async applyFilters(field?: string) {
    if(!field) await new Promise(resolve => { setTimeout(() => resolve(null), 300); });
    this._dataTrackingSub?.unsubscribe();
    this.bounds = new google.maps.LatLngBounds();
    if(this.geozones.length > 0){ this.drawGeozones()}

    // Toggle geozones. This don't need debouncing
    this.polygons.forEach((_, k) => {
      this.polygons[k].setVisible((this.geozones.indexOf(k) > -1));
    });

    if (field === 'geozones') {
      this.fitBounds();
      await new Promise(resolve => { setTimeout(() => resolve(null), 2000); });
      this.getRecursively()
    }

    if (field === 'tags') {
      this.alarmFilters.TagAlarmFilter = new CoreTypes.AssetTrackingTagsAlarmFilter();
      let findWithoutActiveAlarms = true;
      let findAlarmsWithoutTags = true;
      let cloneAlarmsTags = [];
      findWithoutActiveAlarms = this.tags.indexOf(0) > -1;
      findAlarmsWithoutTags = this.tags.indexOf(1) > -1;
      this.tagsList.map((tag, i) => {
        if (this.tags.indexOf(i) > -1 && tag.id !== 0 && tag.id !== 1) { cloneAlarmsTags.push(tag.name); }
      });
      this.alarmFilters.TagAlarmFilter.ShowWithoutActiveAlarms = findWithoutActiveAlarms;
      this.alarmFilters.TagAlarmFilter.ShowWithAlarmsWithoutTags = findAlarmsWithoutTags;
      this.alarmFilters.TagAlarmFilter.AlarmTags = cloneAlarmsTags;
    }

    clearTimeout(this.debounceFilters);
    this.debounceFilters = setTimeout(() => {
      if(this.dateFrom && !this.datetimePipe.transform(this.dateFrom)?.toString()) {
        this.dateFrom = this.datepickerToDateTimeDT(this.dateFrom);
      }

      this.isToday = this.datetimePipe.transform(this.dateFrom).toDateString() === this.today.toDateString();
      if (!this.isToday) { this.showRoute = true; }
      if (field !== 'geozones') {
        const changeDay = (JSON.stringify(this.dateFrom) !== JSON.stringify(this.lastDate));
        // If change day, clear current position and route of all endpoints
        if (changeDay) {
          this.clearAssetsRoutes();
          this.mapAssets = [];
        }
        if (!this.showRoute) {
          this.clearAssetsRoutes();
          this.assetsMultiSelectSettings = {...this.multiSelectSettings, selectionLimit: 0};
        } else {
          //this.clearRoutes();
          if(this.assets.length > 5 && field === 'showRoute') {
            this.showRouteModal.open();
            this.saveShowRouter = false;
            this.assetsMultiSelectSettings = {...this.multiSelectSettings, selectionLimit: 5};
            this.assetsRoute = this.assetsRoute.splice(0, 0);
          } else if(this.assets.length < 6 || this.assets.length > 5) {
            this.assetsMultiSelectSettings = {...this.multiSelectSettings, selectionLimit: 5};
            this.assets = this.assets.splice(0, 5);
          }
          if(field === 'AssetsRoute'){
            this.assets = this.assetsRoute;
            this.showRouteModal.close();
          }
        }

        if(this.assetTrackingPermissions.CanFilterDrivers) { this.filterVehicleDrivers(); }

        this.mapAssets.forEach((a, k) => {
          if (!a) { return; }
          const index = this.assets.findIndex(f => f === a.Asset.AssetID);
          const driverIndex = (!this.drivers?.length)
            ? 1
            : this.drivers.findIndex(d => a.Asset.AssetVehicleData.VehicleDrivers.indexOf(d) > -1);
          if (index < 0 || driverIndex < 0 || field === 'tags') {
            if (this.snappedCoordinates[k]) {
              this.snappedCoordinates[k].snappedPolyline.setMap(null);
              this.snappedCoordinates[k] = null;
            }
            this.mapAssets[k] = null;
          }
        });
        if(!this.firstExecution) { this.fitBounds(); }
        this.requestToken = null;
        this.clearAssetsRoutes();
        this.getRecursively();
      }
    }, 300);
  }

   getRecursively(): any {
      if (this.isDestroyed) { return; }
      if(this._dataTrackingSub) { this._dataTrackingSub.unsubscribe(); }
      this._dataTrackingSub = this.getAssetTracking().
      pipe(
        tap(res => {}),
        switchMap(res => {
          if (res) {
            return of(res);
          } else {
            return this.getRecursively();
          }
        })
      ).subscribe((data: CoreTypes.AssetTrackingDataPacket) => {
       this.getRecursively();
      }, (interval) => {
        this._intervalDataPackages = interval;
        this.timer = setTimeout(()=> this.getRecursively(), this._intervalDataPackages);
      })
    }

  getAssetTracking(): Observable<CoreTypes.AssetTrackingDataPacket> {
    if (this.isDestroyed) { return; }
    this.executionNumber++;
    let executionNumber: number = this.executionNumber;
    this.assetTrackingParameters = {
      Date: (this.isToday) ? null : this.dateFrom,
      AlarmFilters: (this.assetTrackingPermissions.AlarmFilters === this.alarmsTags.usingTags || this.isSharedView) ? this.alarmFilters : null,
      AssetsIDs: (this.assetTrackingPermissions.CanFilterAssets || this.isSharedView) ? this.assets : null,
      DriversIDs: (this.assetTrackingPermissions.CanFilterDrivers || this.isSharedView) ? this.drivers : null,
      GeozoneIDs: (this.assetTrackingPermissions.CanShowGeozones || this.isSharedView) ? this.geozones :  null,
      ReturnRoute: (this.assetTrackingPermissions.CanShowRoutes || this.isSharedView) ? this.showRoute : false
    };
    return new Observable(observer => {
      this.coreProxyService.AssetService.GetAssetTrackingData(
        this.accessToken,
        this.requestToken,
        this.facilityId,
        this.assetTrackingParameters,
        res => {
          const filtersChange = (this.requestToken === null);
          if ((this.requestToken && this.requestToken !== res.RequestToken) || this.isDestroyed) { observer.next(res); return; }

          if(executionNumber !== this.executionNumber) {
            this.firstExecution = false;
            observer.next(res);
            return;
          }
          try {
            this.showCommercialPins = res.MapSettings.ShowCommercialPins;
            if(this.firstExecution || filtersChange) {
              this.showSatellitalView = res.MapSettings.SatellitalView;
              this.showSatellitalView ? this.map.setMapTypeId('satellite') : this.map.setMapTypeId('roadmap');
            }
            this.setSettings();
            if (res.Assets?.length) {
              res.Assets.forEach(asset => {
                let index = this.mapAssets.findIndex(f => f?.Asset?.AssetID === asset.Asset.AssetID);
                index = (index > -1) ? index : this.mapAssets.length;
                let lastRouteIndex = -1;
                // If the element already exists on list, update values
                if (index > -1) {
                  if (!this.mapAssets[index]) {
                    this.mapAssets[index] = new assetsMapV2()
                  }
                  this.mapAssets[index].Asset = asset.Asset;
                  this.mapAssets[index].Alarms = asset.Alarms;
                  this.mapAssets[index].LastStatusLocalDateTime = asset.LastStatusLocalDateTime;
                  this.mapAssets[index].LastStatusLocalDateTimeString = asset.LastStatusLocalDateTimeString;
                  this.mapAssets[index].iconUrl = this.getMarkerIcon(asset);
                  if (asset.CurrentLocation.Latitude !== 0 || asset.CurrentLocation.Longitude !== 0 || asset.CurrentLocation.Flags !== 0)
                    this.mapAssets[index].CurrentLocation = asset.CurrentLocation;
                  lastRouteIndex = this.mapAssets[index].RouteTrackingData?.length-1;
                  if (lastRouteIndex > -1) {
                    const lastRouteDateTime = this.datetimePipe.transform(
                      this.mapAssets[index].RouteTrackingData[lastRouteIndex].UTCDateTime
                    );
                    this.mapAssets[index].RouteTrackingData = this.mapAssets[index].RouteTrackingData.concat(
                      asset.RouteTrackingData.filter(route =>
                        this.datetimePipe.transform(route.UTCDateTime) > lastRouteDateTime
                      )
                    );
                  } else {
                    this.mapAssets[index].RouteTrackingData = asset.RouteTrackingData;
                  }
                }

                // If do not have current location, use the last route register
                /*if (
                  this.mapAssets[index] &&
                  !this.mapAssets[index]?.CurrentLocation?.Latitude &&
                  !this.mapAssets[index]?.CurrentLocation?.Longitude &&
                  lastRouteIndex > -1
                ) {
                  this.mapAssets[index].CurrentLocation = this.mapAssets[index].RouteTrackingData[lastRouteIndex].LocationTracker;
                }*/

                if (asset.RouteTrackingData?.length && this.showRoute) {
                  this.makeRoute(asset.RouteTrackingData, asset.Asset.AssetID);
                }
              });
            }

            if (!this.isSharedView && this.firstExecution && res.MapSettings.InitialViewNE && res.MapSettings.InitialViewSW) {
              var sw = new google.maps.LatLng(res.MapSettings.InitialViewSW.Latitude, res.MapSettings.InitialViewSW.Longitude);
              var ne = new google.maps.LatLng(res.MapSettings.InitialViewNE.Latitude, res.MapSettings.InitialViewNE.Longitude);
              this.bounds = new google.maps.LatLngBounds(sw, ne);
              this.initialLatitude = (sw.lat() + ne.lat()) / 2;
              this.initialLongitude = (sw.lng() + ne.lng()) / 2;
              this.initialZoom = 12; 
            
              this.centerMapInitially();
              this.map.fitBounds(this.bounds);
            } else if(this.firstExecution && ((!res.MapSettings.InitialViewNE && !res.MapSettings.InitialViewSW) || this.isSharedView)) {
              this.fitBounds();
            }

            if (!this.firstExecution && filtersChange) { this.fitBounds(); }
            this.firstExecution = false;
            this.lastDate = JSON.parse(JSON.stringify(this.dateFrom));
            if (!this.isToday) { return; }
            // Update requestToken and go to the next iteration
            this.requestToken = res.RequestToken;
            // setTimeout(() => this.getAssetTracking(), 1000);
            observer.next(res);
          } catch (error) {
            this.requestToken = null;
            observer.error(5000);
          }
        },
        err => {
          this.requestToken = null;
          observer.error(5000);
          // setTimeout(() => this.getAssetTracking(), 5000);
          this.appService.showException(err);
        }
      );
    });
  }


  makeRoute(path: CoreTypes.AssetRouteTrackingData[], assetId: number) {
    const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let labelIndex = 0;
    if (!this.showRoute) { return; }
    let index = this.mapAssets.findIndex(f => f?.Asset?.AssetID === assetId);
    index = (index > -1) ? index : this.mapAssets.length;
    if (!this.snappedCoordinates[index]) {
      this.snappedCoordinates[index] = {
        ...new SnappedCoordinates(),
        snappedPath: []
      };
    }
    const polylinePath: google.maps.LatLng[] = this.snappedCoordinates[index].snappedPath.map(c => c.coordinates);
    const lastPolyline = polylinePath[polylinePath.length];

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    if (this.showRoute) {
      for (var i = 0; i < path.length; i++) {
        const placeId = this.datetimePipe.transform(path[i].UTCDateTime).toString();
        if (this.snappedCoordinates[index].snappedPath.findIndex(p => p.placeId === placeId) > -1) { continue; }
        const coordinates = new google.maps.LatLng(path[i].LocationTracker.Latitude, path[i].LocationTracker.Longitude);
        /* GENERACION DE WAYPOINTS INICIO-INTERMEDIOS-FIN */
        this.mapAssets.forEach((asset, k) => {
          if (asset?.CurrentLocation && asset?.CurrentLocation?.Latitude && asset?.CurrentLocation?.Longitude) {
            this.bounds.extend({lat: asset.CurrentLocation.Latitude, lng: asset.CurrentLocation.Longitude});
          }
        });

        if(i == 0){
          let label = labels[labelIndex++ % labels.length];
          let coordinates = new google.maps.LatLng(path[i].LocationTracker.Latitude, path[i].LocationTracker.Longitude);
          this.addMarker(coordinates, 'assets/icons/origin.png', label);
        }else if(i == path.length - 1){
          if (this.isToday){
            /* tomo el market de la posicion actual como fin recorrido */
          }else{
            let label = labels[labelIndex++ % labels.length];
            let coordinates = new google.maps.LatLng(path[i].LocationTracker.Latitude, path[i].LocationTracker.Longitude);
            this.addMarker(coordinates, 'assets/icons/destiny.png', label);
          }
        }else{
          /* Puntos Intermedios */
/*           let label = labels[labelIndex++ % labels.length];
          let coordinates = new google.maps.LatLng(path[i].LocationTracker.Latitude, path[i].LocationTracker.Longitude);
          this.addMarker(coordinates, 'assets/icons/waypoints.png', label); */
        }
        if (lastPolyline?.equals(coordinates)) { continue; }
        polylinePath.push(coordinates);
        this.snappedCoordinates[index].snappedPath.push({
          coordinates,
          placeId
        });
      }
    }else{
      this.hideMarkers();
      this.deleteMarkers();
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // Polyline already exists
    if (this.snappedCoordinates[index]?.snappedPolyline) {
      // Just update path
      this.snappedCoordinates[index].snappedPolyline.setPath(polylinePath);
      return;
    }

    const colors = [
      'rgb(255,205,86)',
      'rgb(255,99,132)',
      'rgb(153,102,255)',
      'rgb(14,226,119)',
      'rgb(54,162,235)',
    ];

    const usedColors = this.snappedCoordinates.filter(s => s?.snappedPolyline).map(c => c.snappedPolyline.get('strokeColor'));
    let color = colors.find(c => usedColors.indexOf(c) < 0) ?? colors[0];

    const polyline = new google.maps.Polyline({
      path: polylinePath,
      strokeColor: color,
      strokeWeight: 4,
      strokeOpacity: 0.9,
      zIndex: 1
    });

    this.snappedCoordinates[index].snappedPolyline = polyline;
    polyline.setMap(this.map);
    google.maps.event.addListener(polyline, 'click', h => {
      var latlng = h.latLng;
      const needle = {
        minDistance: 9999999999, //silly high
        index: -1,
        latlng: null
      };
      polyline.getPath().forEach((routePoint, k) => {
        const dist = google.maps.geometry.spherical.computeDistanceBetween(latlng, routePoint);
        if (dist < needle.minDistance) {
          needle.minDistance = dist;
          needle.index = k;
          needle.latlng = routePoint;
        }
      });
      this.openDetail(assetId, path[needle.index]);
    });
  }


  // Adds a marker to the map and push to the array.
  addMarker(position: google.maps.LatLng | google.maps.LatLngLiteral, icon, label) {
  const marker = new google.maps.Marker({
    position : position,
    map : this.map,
    icon: icon,
    label: label,
  });
    this.markerArray.push(marker);
  }

  // Removes the markers from the map, but keeps them in the array.
  hideMarkers(): void {
    this.setMapOnAll(null);
  }

  // Sets the map on all markers in the array.
  setMapOnAll(map: google.maps.Map | null) {
    for (let i = 0; i < this.markerArray.length; i++) {
      this.markerArray[i].setMap(map);
    }
  }

  // Deletes all markers in the array by removing references to them.
  deleteMarkers(): void {
    this.hideMarkers();
    this.markerArray = [];
  }

  clearAssetsRoutes() {
    this.snappedCoordinates.forEach(item => item?.snappedPolyline?.setMap(null));
    this.snappedCoordinates = [];
    this.deleteMarkers();
    this.hideMarkers();
  }

  openDetail(assetId: number, routePoint?: CoreTypes.AssetRouteTrackingData) {
    this.detailRequestToken = null;
    this.assetDetail = null;
    this.assetDetailStatus = 1;
    this.executionNumber = 0;
    this.detailModal.open();
    this.getDetailData(assetId, routePoint);
    setTimeout(() => this.cdr.detectChanges(), 150);
  }

  getDetailData(assetId: number, routePoint?: CoreTypes.AssetRouteTrackingData) {
    this.executionNumber++;
    let executionNumber: number = this.executionNumber;
    if (
      !this.detailModal.isOpened ||
      (this.assetDetail?.Asset?.AssetID !== assetId && this.detailRequestToken)
    ) { return; }
    if (this.assetDetail === null) {
      const index = this.mapAssets.findIndex(a => a?.Asset?.AssetID === assetId);
      this.assetDetail = {
        ...new CoreTypes.AssetTrackingDetailDataPacket(),
        Asset: JSON.parse(JSON.stringify(this.mapAssets[index].Asset))
      }
    }
    this.assetDetailDate = routePoint?.UTCDateTime;
    this.coreProxyService.AssetService.GetAssetTrackingDetailData(
      this.accessToken,
      this.facilityId,
      this.detailRequestToken,
      this.assetDetailDate,
      assetId,
      res => {
/*      if (assetId !== this.assetDetail.Asset.AssetID || executionNumber !== this.executionNumber){
            console.log('return');
            return;
        } */

        if (this.executionNumber > 5){
          return;
        }

        if (!this.detailRequestToken) {
          this.assetDetail = res;
          if(res?.Asset.AssetID){
            this.assetDetailStatus = 0;
          }else{
            this.assetDetailStatus = 1;
          }
        } else {
          if (res?.Asset.AssetID) {
            this.assetDetail.Asset = res.Asset;
            this.assetDetail.DriverAccounts = res.DriverAccounts;
            this.assetDetail.Alarms = res.Alarms;
            this.assetDetailStatus = 0;
          }
          if (res.EndpointsStatus?.length) {
            res.EndpointsStatus.forEach(ep => {
              const index = this.assetDetail.EndpointsStatus.findIndex(epl => epl.EndpointID === ep.EndpointID);
              if (index > -1) { this.assetDetail.EndpointsStatus[index] = ep; }
            });
          }
        }
        this.cdr.detectChanges();
        if (routePoint) { return; }
        this.detailRequestToken = res.RequestToken;
        this.getDetailData(assetId, routePoint);
      },
      err => {
        this.appService.showException(err);
        this.detailRequestToken = '';
        setTimeout(() => this.getDetailData(assetId, routePoint), 5000);
      }
    );
  }

  datepickerToDateTimeDT(date): CoreTypes.DateTimeDT {
    return {
      Time: { Hour: 0, Minute: 0, Second: 0, Millisecond: 0 },
      Date: {
        Day: date.day,
        Month: date.month,
        Year: date.year,
      }
    }
  }

  sharedAssets() {
    this.sharedCommonService.onShareComponent.next({type: 'assetsTracking', data: {
      assets: this.assets,
      geozones: this.geozones,
      date: (this.isToday) ? null : this.dateFrom,
      returnRoute: this.showRoute,
      drivers: this.drivers,
      alarmFilters: this.alarmFilters
    }});
  }

  setSettings() {
    const poiIndex = this.commonMapService.Styles.findIndex(s => s.featureType === 'poi');
    if (poiIndex > -1 && this.commonMapService.Styles[poiIndex].stylers[0]?.visibility) {
      this.commonMapService.Styles[poiIndex].stylers[0].visibility = (this.showCommercialPins) ? 'on' : 'off';
      this.mapStyles = this.commonMapService.Styles;
      this.map.setOptions({styles: this.mapStyles});
    }
  }

  fitBounds() {
    this.bounds = new google.maps.LatLngBounds();
    this.polygons.forEach((_, k) => {
      if ((this.geozones.indexOf(k) > -1)) {
        this.polygons[k].getPath().forEach(point => {
          this.bounds.extend(point);
        });
      }
    });
    this.mapAssets.forEach((asset, k) => {
      if (asset?.CurrentLocation && asset?.CurrentLocation?.Latitude && asset?.CurrentLocation?.Longitude) {
        this.bounds.extend({lat: asset.CurrentLocation.Latitude, lng: asset.CurrentLocation.Longitude});
      }
      this.snappedCoordinates[k]?.snappedPath.forEach(point => {
        this.bounds.extend(point.coordinates);
      });
    });
    this.map.fitBounds(this.bounds);
  }

  saveAssetsRoutes(formElement) {
    this.saveShowRouter = true;
    if( formElement && !formElement.form.valid) {
      const getErrorMessage = this.formValidatorService.getValidationErrors(formElement);
      this.errorMessage = getErrorMessage;
      return;
    }
    this.applyFilters('AssetsRoute');
  }

  onCloseModalRoutes() {
    this.showRoute = false;
    this.showRouteModal.close();
    this.clearAssetsRoutes();
  }

  closeModalRoutes() {
    if(!this.showRoute) {
      this.clearAssetsRoutes();
    }else{
      this.clearAssetsRoutes();
      if(this.saveShowRouter){
        this.showRoute = true;
      }else{
        this.showRoute = false;
      }
    }
  }

  getMarkerIcon(assetMap: CoreTypes.AssetMap): any | google.maps.ReadonlyIcon | google.maps.ReadonlySymbol {
    if(!assetMap) return;
    let findCustomIcon = this.appService.mapIconSet?.value.find(x => x.MapIconID === assetMap?.Asset.IconID);
    let url = findCustomIcon ? findCustomIcon.Default : "assets/icons/default.png";

    if (assetMap?.Alarms?.DeviceHighAlarmCount || assetMap?.Alarms?.HighAlarmCount)
      url =  findCustomIcon ? findCustomIcon.High : "assets/icons/danger.png";
    else if (assetMap?.Alarms?.DeviceMidAlarmCount || assetMap?.Alarms?.MidAlarmCount)
      url = findCustomIcon ? findCustomIcon.Mid : "assets/icons/warning.png";
    else if (assetMap?.Alarms?.DeviceLowAlarmCount || assetMap?.Alarms?.LowAlarmCount)
      url = findCustomIcon ? findCustomIcon.Low : "assets/icons/low.png";
    else if (assetMap?.Alarms?.DeviceInfoAlarmCount  || assetMap?.Alarms?.InfoAlarmCount)
      url =  findCustomIcon ? findCustomIcon.Information :"assets/icons/info.png";

    return url;
  }

  getAssetsAlertTags() {
    this.tags = [];
    this.tagsList = [];
    this.alarmFilters = new CoreTypes.AssetTrackingAlarmFilters();
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    this.coreProxyService.AlarmService.GetAssetsAlertTags(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      this.assetTrackingPermissions.CanFilterAssets ? this.assetsForTags : null,
      data => {
        optionsList = [
          { name: this.appService.CoreCommonLiterals?.ShowWithoutActiveAlarms, id: 0 },
          { name: this.appService.CoreCommonLiterals?.ShowAlarmsWithoutTags, id: 1 },
        ];
        this.tags.push(0, 1);
        data.map((tag, i) => {
          this.tags.push(i+2);
          optionsList.push({ name: tag, id: i+2 })
        });
        this.tagsList = optionsList;
        this.applyFilters('tags');
      },
      err => {
        this.appService.showException(err);
      }
    )
  };

  getEndpointAlertTags() {
    let optionsList:  Array<IMultiSelectOption> = new Array<IMultiSelectOption>();
    this.coreProxyService.AlarmService.GetEndpointAlertTags(
      this.appService.getAccessToken(),
      this.appService.getFacilityID(),
      this.endpointsIDs,
      data => { },
      err => {
        this.appService.showException(err);
      }
    )
  };
}
